import { useState } from 'react';
import { supabase } from '../lib/supabase';

export default function ResetPasswordPage() {
  const [password, setPassword]   = useState('');
  const [confirm, setConfirm]     = useState('');
  const [loading, setLoading]     = useState(false);
  const [error, setError]         = useState('');
  const [success, setSuccess]     = useState(false);

  async function handleReset() {
    if (!password) return setError('Please enter a new password');
    if (password.length < 6) return setError('Password must be at least 6 characters');
    if (password !== confirm) return setError('Passwords do not match');

    setLoading(true); setError('');
    try {
      const { error: err } = await supabase.auth.updateUser({ password });
      if (err) throw err;
      setSuccess(true);
      sessionStorage.removeItem('authType');
      // Redirect to app after 2 seconds
      setTimeout(() => {
        window.location.href = '/';
      }, 2000);
    } catch(e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }

  const s = {
    wrap: { minHeight:'100vh', background:'#FAF7F2', display:'flex', alignItems:'center', justifyContent:'center', padding:20 },
    card: { background:'white', borderRadius:24, padding:'40px 36px', width:'100%', maxWidth:420, boxShadow:'0 8px 40px rgba(44,26,14,.12)', border:'1px solid #EDE5D8' },
    label: { display:'block', fontSize:11, fontWeight:500, letterSpacing:'.07em', textTransform:'uppercase', color:'#7A6555', marginBottom:6 },
    input: { width:'100%', padding:'10px 13px', border:'1px solid #E5D9C8', borderRadius:10, fontFamily:'Jost,sans-serif', fontSize:14, color:'#2C1A0E', outline:'none', marginBottom:16 },
    btn: { width:'100%', padding:'12px', background:'#C4612A', color:'white', border:'none', borderRadius:10, fontFamily:'Jost,sans-serif', fontSize:15, fontWeight:500, cursor:'pointer' },
  };

  return (
    <div style={s.wrap}>
      <div style={s.card}>
        <div style={{textAlign:'center',marginBottom:28}}>
          <div style={{fontSize:40,marginBottom:12}}>🔑</div>
          <h2 style={{fontFamily:'Cormorant Garamond,serif',fontSize:28,color:'#2C1A0E',marginBottom:6}}>
            Set a new password
          </h2>
          <p style={{fontSize:13,color:'#7A6555'}}>Choose a strong password for your account</p>
        </div>

        {success ? (
          <div style={{background:'#E8F5E9',color:'#1B5E20',padding:'16px',borderRadius:10,textAlign:'center',fontSize:14}}>
            Password updated! Redirecting you to the app…
          </div>
        ) : (
          <>
            {error && (
              <div style={{background:'#FFEBEE',color:'#B71C1C',padding:'10px 14px',borderRadius:8,fontSize:13,marginBottom:16}}>
                {error}
              </div>
            )}
            <label style={s.label}>New password</label>
            <input
              type="password"
              style={s.input}
              placeholder="At least 6 characters"
              value={password}
              onChange={e=>setPassword(e.target.value)}
              autoFocus
            />
            <label style={s.label}>Confirm password</label>
            <input
              type="password"
              style={s.input}
              placeholder="Repeat your password"
              value={confirm}
              onChange={e=>setConfirm(e.target.value)}
              onKeyDown={e=>e.key==='Enter'&&handleReset()}
            />
            <button
              style={{...s.btn, opacity:loading?0.6:1}}
              disabled={loading}
              onClick={handleReset}>
              {loading ? 'Saving…' : 'Set new password'}
            </button>
          </>
        )}
      </div>
    </div>
  );
}